define('Facets.Translator.SortItems.Fix', [
    'Facets.Translator',

    'underscore'
],
function FacetsTranslatorFix(
    FacetsTranslator,

    _
) {
    'use strict';

    /**
     * Sort fix for commerce category items
     */
    FacetsTranslator.prototype.getApiParams = _(FacetsTranslator.prototype.getApiParams).wrap(function getApiParams(fn) {
        var params = fn.apply(this, _.toArray(arguments).slice(1));

        if (params && params.sort && params.sort.indexOf('commercecategory:desc') !== -1) {
            params.sort = params.sort.replace('commercecategory:desc', 'commercecategory:asc');
        }

        return params;
    });
});

